import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { Link, useParams } from "react-router-dom";
import Logo from "../../../assets/logosz.png";
import { BtnSubmit } from "../../button/button-submit/button-submit";
import reqColaborador from "../../../services/reqMultiTenant/reqColaborador";
import { ToastContainer } from "react-toastify";
import { handleMessageSuccess } from "../../toast";
import { clearSessionAndRedirectLogin } from "../../../util/libLocalStorage";

const schema = z
	.object({
		senha: z.string().min(6, "Senha deve ter no mínimo 6 caracteres"),
		confirmarSenha: z.string().min(6, "Confirmação de senha deve ter no mínimo 6 caracteres"),
	})
	.refine((data) => data.senha === data.confirmarSenha, {
		message: "As senhas não coincidem",
		path: ["confirmarSenha"],
	});

const Forgot = () => {
	const {
		register,
		handleSubmit,
		formState: { errors, isSubmitting },
	} = useForm({
		resolver: zodResolver(schema),
	});

	const [loading, setLoading] = useState(false);
	const [mensagemDeErro, setMensagemDeErro] = useState("");
	const [isPasswordChanged, setIsPasswordChanged] = useState(false); //se a senha foi alterada com sucesso
	const [statusError, setStatusError] = useState(0);
	const { token } = useParams();

	const onSubmit = async (data) => {
		try {
			setLoading(true);
			setMensagemDeErro("");
			setIsPasswordChanged(false);
			setStatusError(0);

			const body = {
				senha: data.senha,
				id_validacao: token,
			};

			const response = await reqColaborador.patchPassword(body);

			if (response.status === 200) {
				setIsPasswordChanged(true);
				handleMessageSuccess("Senha alterada com sucesso");
			} else {
				throw new Error("Erro ao alterar senha");
			}
		} catch (error) {
			setStatusError(error.status);
			setMensagemDeErro(error.message);
		} finally {
			setLoading(false);
		}
	};

	const redirectLogin = () => {
		clearSessionAndRedirectLogin();
	};

	return (
		<div className="flex flex-col justify-center items-center w-full text-center p-5">
			<ToastContainer />
			{!isPasswordChanged ? (
				<>
					<form className="w-full max-w-md" onSubmit={handleSubmit(onSubmit)}>
						<div className="flex justify-center">
							<img className="mt-3" src={Logo} alt="SZ Delivery" />
						</div>
						<h3 className="text-2xl font-semibold mb-4 mt-4">Alterar Senha</h3>
						<p className="flex justify-start text-sm mb-1">Por favor, insira nova senha.</p>

						{/* Campo de Senha */}
						<div className="form-floating mb-3">
							<input
								type="password"
								{...register("senha")}
								className="form-control"
								id="floatingSenha"
								placeholder="Senha"
								disabled={isSubmitting}
							/>
							<label htmlFor="floatingSenha" className="text-slate-500">
								Senha
							</label>
							{errors.senha && <p className="text-red-500 text-sm">{errors.senha.message}</p>}
						</div>

						{/* Campo de Confirmar Senha */}
						<div className="form-floating mb-3">
							<input
								type="password"
								{...register("confirmarSenha")}
								className="form-control"
								id="floatingConfirmarSenha"
								placeholder="Confirmar Senha"
								disabled={isSubmitting}
							/>
							<label htmlFor="floatingConfirmarSenha" className="text-slate-500">
								Confirmar Senha
							</label>
							{errors.confirmarSenha && (
								<p className="text-red-500 text-sm">{errors.confirmarSenha.message}</p>
							)}
						</div>

						<button type="submit" className={`w-full btn btn-primary mb-3`} disabled={loading}>
							{!loading ? "Trocar Senha" : "Trocando"}
							{loading && (
								<>
									<span
										className="spinner-grow custom-spinner spinner-grow-sm text-color me-2 ms-2"
										role="status"
									></span>
									<span
										className="spinner-grow custom-spinner spinner-grow-sm text-color me-2"
										role="status"
									></span>
								</>
							)}
						</button>
						{/* {isPasswordChanged && (
					
				)} */}
					</form>
					{mensagemDeErro?.length > 0 ? (
						<div className="alert alert-danger mt-2" role="alert">
							{mensagemDeErro}
						</div>
					) : null}
					{statusError !== 403 ? (
						<span className="block text-sm mb-3">
							<Link to="/login" className="text-blue-500 underline">
								Voltar para o login
							</Link>
						</span>
					) : (
						<span className="block text-sm mb-3">
							<Link to="/recovery" className="text-blue-500 underline">
								Gerar Token Novamente
							</Link>
						</span>
					)}
				</>
			) : (
				<div className="max-w-md">
					<div className="flex justify-center">
						<img className="mt-3" src={Logo} alt="SZ Delivery" />
					</div>
					<h3 className="text-2xl font-semibold mb-4 mt-4">Alterar Senha</h3>
					<h3 className="text-green-900 text-sm mb-3">{`Sua senha foi alterada com sucesso.`}</h3>

					<button className="w-full btn btn-primary mb-3" onClick={redirectLogin}>
						Login
					</button>
				</div>
			)}
		</div>
	);
};

export default Forgot;
